import React, { Component, Fragment } from 'react';

import { checkUndefine, capitalizeFirstLetter } from '../../../../../../../../helpers/functions';
import { CURRENCY, DATE_TIME_FORMAT } from '../../../../../../../../constants/Define';
import {
    FormWrapperInputComponent, DatePickerComponent
} from "../../../../../../common/component/Index";
import Wrapper from '../../../../../../common/component/Wrapper';
import Switch from '../../../../../../common/component/Switch';
import Ripple from '../../../../../../common/component/Ripple';
import Input, { InputGroup } from '../../../../../../common/component/Input';
import AntSelect, { AntOption } from '../../../../../../common/component/AntSelect';
import TourLineTicket from './TourLineTicket'
import moment from 'moment';
import { Icon } from 'antd';

export default class TourLineContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ticketInit: []
        };
    }

    componentDidMount() {
        if(this.props.tourLine && this.props.tourLine.id) {
            this.props.getItemTicket(this.props.tourLine.id)
        }
    }

    render() {
        const { t, tourLine, index, validation, hidePrices, allowUpdateContent, isTour, loading} = this.props;
        return (
            <Fragment>
            <Wrapper className="col-md-12 row">
                {!this.props.onSelectDateRange && isTour &&
                    <Wrapper className={hidePrices ? 'col-md-12' : "col-md-5"}>
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={tourLine.departureDate}
                            validation={validation[index] && validation[index].departureDate}
                            labelTitle={t(`item.tour.departureDate`)}
                        >
                            <DatePickerComponent className={`form-control applyDates`}
                                allowClear={false}
                                format={DATE_TIME_FORMAT.SHORT_DATE}
                                disabledDate={this.disabledDate}
                                hmsComponent={`DatePicker`}
                                style={{ padding: 0, border: 0 }}
                                onChange={date => this.props.onSelectDate(date, index)} name={`applyDates`}
                                placeholder={t('item.tour.departureDate')}
                                value={tourLine.departureDate}
                                disabled={!!tourLine.id}
                            />
                        </FormWrapperInputComponent>

                    </Wrapper>
                }
                {!!this.props.onSelectDateRange &&
                    <Wrapper className={hidePrices ? 'col-md-12' : "col-md-5"}>
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={tourLine.fromDate}
                            validation={validation[index] && validation[index].departureDate}
                            labelTitle={`${t(`item.tour.departureDate`)} - ${t(`item.tour.destinationDate`)}`}
                        >
                            <DatePickerComponent className={`form-control applyDates`}
                                allowClear={false}
                                format={DATE_TIME_FORMAT.SHORT_DATE}
                                disabledDate={this.disabledDate}
                                hmsComponent={`RangePicker`}
                                style={{ padding: 0, border: 0 }}
                                onChange={date => this.props.onSelectDateRange(date, index)} name={`applyDates`}
                                placeholder={t('item.tour.departureDate')}
                                value={[tourLine.fromDate, tourLine.toDate]}
                            />
                        </FormWrapperInputComponent>

                    </Wrapper>
                }
                <Wrapper className={hidePrices ? 'col-md-8' : "col-md-5"}>
                    <FormWrapperInputComponent
                        isRequired={true}
                        isValidation={true}
                        dataValidation={tourLine.seats}
                        validation={validation[index] && validation[index].seats}
                        labelTitle={t(`item.tour.seat`)}
                    >
                        <Input placeholder="" type={`number`}
                            className={`form-control`}
                            name={`seats`}
                            onChange={e => this.props.onChange(index, 'seats', Number(e.target.value))}
                            value={checkUndefine(tourLine.seats)} />
                    </FormWrapperInputComponent>
                </Wrapper>
                {!!this.props.showStep &&
                    <Wrapper className={hidePrices ? 'col-md-4' : "col-md-2"}>
                        <FormWrapperInputComponent
                            isRequired={true}
                            isValidation={true}
                            dataValidation={tourLine.step}
                            validation={validation[index] && validation[index].step}
                            labelTitle={t(`item.tour.step`)}
                        >
                            <Input placeholder="" type={`number`}
                                className={`form-control`}
                                name={`step`}
                                onChange={e => this.props.onChange(index, 'step', Number(e.target.value))}
                                value={checkUndefine(tourLine.step)} />
                        </FormWrapperInputComponent>
                    </Wrapper>
                }
                {this.props.showActiveToggle &&
                    <Wrapper className={hidePrices ? 'col-md-4' : "col-md-2"}>
                        <FormWrapperInputComponent
                            labelTitle={t(`item.tour.isEnabled`)}
                        >
                            <Wrapper>
                                <Switch checked={tourLine.isEnabled} onChange={checked => this.props.onChange(index, 'isEnabled', checked)} />
                            </Wrapper>
                        </FormWrapperInputComponent>
                    </Wrapper>
                }
                {!this.props.withoutSaveBtn &&
                    <Ripple 
                        color="white" 
                        className="btn btn-save" 
                        disabled={!allowUpdateContent || loading}
                        onClick={() => this.props.onSave(tourLine, index)}>
                            <Icon type="save" className="mr-2" />{t('action.save')}
                    </Ripple>
                }

            </Wrapper>


            {!this.props.hideTickets && <TourLineTicket 
                    tickets={tourLine.tickets}
                    onDelete={this.props.deleteItemTicketDetail}
                    tourLineId={tourLine.id}
                    onInitTickets={this.props.onInitTickets}
                    allowUpdateContent={allowUpdateContent}
                />}
            </Fragment>
        )
    }

    disabledDate = (current) => {
        const { lengthOfTour, stayStartDate, stayEndDate, type } = this.props.tour
        if (type === 7) return ;  // 7 : VinWonder New 
        const stayNumber = Number(lengthOfTour.split('.')[0])
        const disabledStart = moment(stayStartDate);
        const disabledEnd = moment(stayEndDate).subtract(stayNumber - 1, 'days');
        return current && (current <= moment(disabledStart) || current > moment(disabledEnd).endOf('days') );
    }
}

TourLineContent.defaultProps = {
    onChange: (fieldName, value) => { },
    onSelectDate: (date, index) => { },
    // onSelectDateRange: (date, index) => { },
    onSave: (tourLine, index) => { },
    showStep: false,
    step: 0,
    dateRange: [],
    withoutSaveBtn: false,
    showActiveToggle: true,
    hidePrices: false,
    hideTickets: false,
    allowUpdateContent: true
}


